<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" id="exampleModalLabel1">Editar Tipo de Sake</h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      mat-dialog-close
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-12">
          <mat-form-field style="width: 100%;">
            <mat-label>Tipo sake</mat-label>
            <input
              type="text"
              formControlName="nombre"
              matInput
              placeholder="Ingrese el tipo de sake"
            />
            <mat-error *ngIf="form.get('nombre').hasError('required')"
              >El canal es <strong>requerida </strong></mat-error
            >
            <mat-error *ngIf="form.get('nombre').hasError('maxlength')"
              >El maximo de letras es <strong>15 </strong></mat-error
            >
            <mat-error *ngIf="form.get('nombre').hasError('pattern')"
              >Solo se admite <strong>letras </strong></mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <button
        [disabled]="form.status != 'VALID'"
        type="submit"
        class="btn btn-info waves-effect float-right"
      >
      <i class="far fa-save"></i>
        Guardar
      </button>
    </form>
  </div>
</div>
